import DaysViewBase from "react-input-calendar/dist/day-view";
import moment from "moment";
export default class DaysView extends DaysViewBase {
    getDays() {
        const { minDate, maxDate, date, isDayDisabled } = this.props;
        const now = date ? date : moment();
        const start = now
            .clone()
            .startOf("month")
            .weekday(0);
        const end = now
            .clone()
            .endOf("month")
            .weekday(6);
        const month = now.month();
        const today = moment();
        const currDay = now.date();
        const year = now.year();
        const days = [];
        moment()
            .range(start, end)
            .by("days", (day) => {
            days.push({
                label: day.format("D"),
                prev: (day.month() < month && !(day.year() > year)) || day.year() < year,
                next: day.month() > month || day.year() > year,
                disabled: day.isBefore(minDate, "day") || day.isAfter(maxDate, "day")
                    || (isDayDisabled && isDayDisabled(day)),
                curr: day.date() === currDay && day.month() === month,
                today: day.date() === today.date()
                    && day.month() === today.month()
                    && day.year() === today.year()
            });
        });
        return days;
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/DatePicker/DaysView.tsx